(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MoveoAudio", [], factory);
	else if(typeof exports === 'object')
		exports["MoveoAudio"] = factory();
	else
		root["MoveoAudio"] = factory();
})(this, function() {
return 